import axios from 'axios';
import { getAuthToken, getToken } from '../actions/auth.js';

let url_to_use = undefined

if(process.env.NODE_ENV === 'development'){
    url_to_use = 'http://localhost:5000/collector-api';
}else{
    url_to_use = process.env.REACT_APP_BACKEND_URL;
}

// Instance Axios avec un délai d'attente personnalisé
const axiosInstance = axios.create({
    baseURL: url_to_use,
    timeout: 300000, // 5 minutes
    headers: {
      'Authorization': `Bearer ${getToken()}`,
      'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  });

const getHeaderCollectorService = (params) => ({headers: {'Authorization': `Bearer ${getToken()}`, timezone : Intl.DateTimeFormat().resolvedOptions().timeZone}, params})
const getHeaderAuthService = () => ({headers: {'Authorization': `Bearer ${getAuthToken()}`}})
const getHeaderAuthMultiPart = (params) => ({headers: {'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${getToken()}`}, params})


// V2 /v2/sport
const V2_url_sport = url_to_use+'/v2/sport';

//v2/sport/all?provider=dsas : tout les sports (deep)
export const getAllV2Sport = async () => axios.get(`${V2_url_sport}/all`, getHeaderCollectorService())

// V2        /v2/events
// /live
// /live/all
// /live/dates/:liveId
const V2_url_event = url_to_use+'/v2/event';

export const getV2LiveDates = (idLive) => axios.get(`${V2_url_event}/live/dates/${idLive}`, getHeaderCollectorService())
export const getV2LiveDetails = (filter) => axios.get(`${V2_url_event}/all`, getHeaderCollectorService({ filter }))

export const postV2Live = async (body) => axios.patch(`${V2_url_event}/live`, body, getHeaderCollectorService())
export const postV2SportEvent = async (body) => axios.patch(`${V2_url_event}`, body, getHeaderCollectorService())

export const postV2SportEventAsOne = async (body) => axios.patch(`${V2_url_event}/update/one`, body, getHeaderCollectorService())

export const getAllV2Live = async (provider) => axios.get(`${V2_url_event}/live/all?provider=${provider}`, getHeaderCollectorService())
///live/all/info
export const getAllV2LiveInfo = () => axios.get(`${V2_url_event}/live/allinfo`, getHeaderCollectorService())
// V2        v2/competition?provider=provider
const V2_url_competitions = url_to_use+'/v2/competition'

// ENDPOINTS

/**
 * Récupère les date d'events du live
 * @param {*} provider 
 * @returns LIVEDTO
 */
export const getV2Competitions = (provider) => axios.get(`${V2_url_competitions}?provider=${provider}`, getHeaderCollectorService())
export const getV2CompetitionDetails = (id) => axios.get(`${V2_url_competitions}/${id}`, getHeaderCollectorService())
export const getV2SportEvents = (filter) => axios.get(`${V2_url_competitions}/sportevent`, getHeaderCollectorService({ filter }))
export const deleteSportEvent = async (id) => axios.delete(`${V2_url_event}/${id}`, getHeaderCollectorService())

export const postV2Competitions = async (competitions) => axios.patch(`${V2_url_competitions}`, competitions, getHeaderCollectorService())
export const postV2Phase = async (phases) => axios.patch(`${V2_url_competitions}/phase`, phases, getHeaderCollectorService())
export const postV2Epreuve = async (epreuves) => axios.patch(`${V2_url_competitions}/epreuve`, epreuves, getHeaderCollectorService())

// V2 /v2/roaster
const V2_url_roaster = url_to_use+'/v2/roaster'

// ENDPOINTS
//v2/roaster/team/all?provider=dsas : idem
//v2/roaster/athlete/all?provider=dsas : tout les joueurs (deep)
///v2/athlete --> create/update joueur(s)
///v2/team  --> create/update team(s)
export const getAllV2Players = async (filter) => axios.get(`${V2_url_roaster}/athlete/all?filter=${filter}`, getHeaderCollectorService())
export const getAllV2Teams = async (filter) => axios.get(`${V2_url_roaster}/team/all?filter=${filter}`, getHeaderCollectorService())

export const getV2PlayerDetails = (id) => axios.get(`${V2_url_roaster}/athlete/${id}`, getHeaderCollectorService())
export const getV2TeamDetails = (id) => axios.get(`${V2_url_roaster}/team/${id}`, getHeaderCollectorService())

export const postV2Player = async (player) => axios.patch(`${V2_url_roaster}/athlete`, player, getHeaderCollectorService())
export const postV2Team = async (team) => axios.patch(`${V2_url_roaster}/team`, team, getHeaderCollectorService())

// V2 /v2/conf
const V2_url_conf = url_to_use+'/v2/conf'

//v2/conf/model/gf?provider=provider : tout les modèles de faits de jeux par provider
export const getAllV2GamefactsModel = async (filter) => axios.get(`${V2_url_conf}/model/gf?filter=${filter}`, getHeaderCollectorService())

// V2 /v2/conf
const V2_url_gamefact = url_to_use+'/v2/gamefact'
export const getAllV2Gamefacts = async (filter) => axios.get(`${V2_url_gamefact}/all?filter=${filter}`, getHeaderCollectorService())

export const postV2Gamefact = async (gamefact) => axios.patch(`${V2_url_gamefact}`, gamefact, getHeaderCollectorService())

export const deleteV2Gamefact = async (id) => axios.delete(`${V2_url_gamefact}/${id}`, getHeaderCollectorService())


const V2_url_live = url_to_use+'/v2/competition'

const url_auth = url_to_use+'/auth';
const url_player = url_to_use+'/players';
const url_competition = url_to_use+'/competitions';
const url_category = url_to_use+'/categories';
const url_team = url_to_use+'/teams';
const url_match = url_to_use+'/matchs';
const url_matchdetail = url_to_use+'/matchdetail';
const url_lives = url_to_use+'/lives';
const url_compositions = url_to_use+'/compositions';

const url_actulive = url_to_use+'/actulives';
const url_gamefact = url_to_use+'/gameFacts';
const url_notation = url_to_use+'/notation';
const url_survey = url_to_use+'/survey';
const url_quizz = url_to_use+'/quizz';
const url_questionbox = url_to_use+'/questionbox';
const url_article = url_to_use+'/article';

const url_data = url_to_use+'/data';

const url_admin = url_to_use+'/admin';

const url_data_sync = url_to_use+'/v2/datasync';


export const loginUser = (credentials) => axios.post(url_to_use+"/auth", credentials)
export const logoutUser = (credentials) => axios.post(url_auth+'/logout', credentials)
export const checkUser = (credentials) => axios.post(url_auth+'/checkUser', credentials, getHeaderCollectorService())
export const getGroups = () => axios.get(url_auth+'/groups', getHeaderAuthService())
export const getUsers = () => axios.get(url_auth+'/users', getHeaderAuthService())

export const getAllApiKeys = () => axios.get(`${url_auth}/api-keys`, getHeaderAuthService())
export const getUserApiKey = (api_data) => axios.post(`${url_auth}/api-data`, api_data, getHeaderCollectorService())
export const getAllUsersApiKeys = () => axios.get(`${url_auth}/users-api-keys`, getHeaderAuthService())
export const attachApiKeyToUser = (data) => axios.post(`${url_auth}/users-api-keys`, data, getHeaderAuthService())
export const detachApiKeyFromUser = (data) => axios.post(`${url_auth}/users-api-keys/detach`, data, getHeaderAuthService());
export const createApiKey = (data) => axios.post(`${url_auth}/api-keys`, data, getHeaderAuthService())
export const updateApiKeyStatus = (id, isActive) => axios.patch(`${url_auth}/api-keys/${id}/status`, { isActive }, getHeaderAuthService());
export const deleteApiKey = (id) => axios.delete(`${url_auth}/api-keys/${id}`, getHeaderAuthService());


export const fetchPlayers = (filters = {}) => axios.get(url_player, getHeaderCollectorService({ filters }))
export const fetchPlayersByTeamId = (id) => axios.get(`${url_player}/${id}`, getHeaderCollectorService())
export const fetchPlayerById = (id) => axios.get(`${url_player}/unique/${id}`, getHeaderCollectorService())
export const getPlayersThirdPartyById = (thirdPartyId, thirdPartyEntityId) => axios.get(`${url_player}/thirdparty/${thirdPartyId}/${thirdPartyEntityId}`, getHeaderCollectorService())
export const createPlayer = (newPlayer, params) => axios.post(url_player, newPlayer, getHeaderAuthMultiPart(params))
export const checkExistingPlayer = (newPlayer) => {
  // Transformer `newPlayer` en query string
  const queryParams = new URLSearchParams(newPlayer).toString();

  // Effectuer la requête GET avec les paramètres dans l'URL
  return axios.get(`${url_player}/check-existing?${queryParams}`, getHeaderCollectorService());
};

export const mergePlayer = (newPlayer, id) => axios.patch(`${url_player}/merge/${id}`, newPlayer, getHeaderAuthMultiPart())
export const premergePlayers = (idPlayer, idsToDelete) => axios.patch(`${url_player}/premergeplayers`, {idPlayer, idsToDelete}, getHeaderCollectorService())
export const mergePlayers = (playerDetails, idsToDelete, activeTeam) => axios.patch(`${url_player}/mergeplayers`, {playerDetails, idsToDelete, activeTeam}, getHeaderCollectorService())
export const createPlayers = (newPlayers) => axios.post(`${url_player}/multiple`, newPlayers, getHeaderCollectorService())
export const updatePlayer = (id, updatedPlayer) => axios.patch(`${url_player}/${id}`, updatedPlayer, getHeaderAuthMultiPart())
export const deletePlayer = (id) => axios.delete(`${url_player}/${id}`, getHeaderCollectorService())

export const fetchCompetitions = (filters = {}) => axios.get(url_competition, getHeaderCollectorService({ filters }))
export const fetchCompetitionById = (id) => axios.get(`${url_competition}/${id}`, getHeaderCollectorService())
export const createCompetition = (newCompetition) => axios.post(url_competition, newCompetition, getHeaderAuthMultiPart())
export const updateCompetition = (id, updatedCompetition) => axios.patch(`${url_competition}/${id}`, updatedCompetition, getHeaderAuthMultiPart())
export const deleteCompetition = (id) => axios.delete(`${url_competition}/${id}`, getHeaderCollectorService())
export const getCalendarCompetition = (id) => axios.get(`${url_competition}/calendar/${id}`, getHeaderCollectorService())
export const checkExistingCompetition = (newCompetition) => {
  // Transformer `newPlayer` en query string
  const queryParams = new URLSearchParams(newCompetition).toString();

  // Effectuer la requête GET avec les paramètres dans l'URL
  return axios.get(`${url_competition}/check-existing?${queryParams}`, getHeaderCollectorService());
};

export const fetchCategories = (filters = {}) => axios.get(url_category, getHeaderCollectorService({ filters }))
export const createCategory = (newCategory) => axios.post(url_category, newCategory, getHeaderCollectorService())
export const updateCategory = (id, updatedCategory) => axios.patch(`${url_category}/${id}`, updatedCategory, getHeaderCollectorService())
export const deleteCategory = (id) => axios.delete(`${url_category}/${id}`, getHeaderCollectorService())

export const fetchTeams = (filters = {}) => axios.get(url_team, getHeaderCollectorService({ filters }))
export const fetchTeamById = (id) => axios.get(`${url_team}/${id}`, getHeaderCollectorService())
export const getTeamsThirdPartyById = (thirdPartyId, thirdPartyEntityId) => axios.get(`${url_team}/thirdparty/${thirdPartyId}/${thirdPartyEntityId}`, getHeaderCollectorService())
export const createTeam = (newTeam) => axios.post(url_team, newTeam, getHeaderAuthMultiPart())
export const updateTeam = (id, updatedTeam) => axios.patch(`${url_team}/${id}`, updatedTeam, getHeaderAuthMultiPart())
export const deleteTeam = (id) => axios.delete(`${url_team}/${id}`, getHeaderCollectorService())
export const checkExistingTeam = (newTeam) => {
  // Transformer `newPlayer` en query string
  const queryParams = new URLSearchParams(newTeam).toString();

  // Effectuer la requête GET avec les paramètres dans l'URL
  return axios.get(`${url_team}/check-existing?${queryParams}`, getHeaderCollectorService());
};

export const fetchMatchs = (filters = {}) => axios.get(url_match, getHeaderCollectorService({ filters }))
export const fetchMatchsByCompetition = (idCompetition) => axios.get(`${url_match}/${idCompetition}`, getHeaderCollectorService())
export const createMatch = (newMatch) => axios.post(url_match, newMatch, getHeaderCollectorService())
export const updateMatch = (id, updatedMatch, type) => axios.patch(`${url_match}/${id}`, updatedMatch, getHeaderCollectorService())
export const forfaitMatch = (id, forfaitTeam) => axios.patch(`${url_match}/forfait/${id}`, {forfaitTeam}, getHeaderCollectorService())
export const updateInfoMatch = (id, updatedMatch) => axios.patch(`${url_match}/info/${id}`, updatedMatch, getHeaderAuthMultiPart())
export const deleteMatch = (id) => axios.delete(`${url_match}/${id}`, getHeaderCollectorService())

export const fetchLives = (filters = {}) => axios.get(url_lives, getHeaderCollectorService({ filters }))
export const createLive = (newLive) => axios.post(url_lives, newLive, getHeaderCollectorService())
export const createLiveByCompetitionDetails = (newLive) => axios.post(`${url_lives}/competitiondetails`, newLive, getHeaderCollectorService())
export const updateLive = (id, updatedLive) => axios.patch(`${url_lives}/${id}`, updatedLive, getHeaderCollectorService())
export const updateLiveByCompetitionDetails = (id, updatedLive) => axios.patch(`${url_lives}/competitiondetails/${id}`, updatedLive, getHeaderCollectorService())
export const deleteLive = (id) => axios.delete(`${url_lives}/${id}`, getHeaderCollectorService())

export const fetchActuLives = (filters = {}) => axios.get(url_actulive, getHeaderCollectorService({ filters }))
export const fetchActuLivesByCompetition = (idCategory) => axios.get(`${url_actulive}/${idCategory}`, getHeaderCollectorService())
export const createActuLive = (newActuLive) => axios.post(url_actulive, newActuLive, getHeaderCollectorService())
export const updateActuLive = (id, updatedActuLive) => axios.patch(`${url_actulive}/${id}`, updatedActuLive, getHeaderCollectorService())
export const deleteActuLive = (id) => axios.delete(`${url_actulive}/${id}`, getHeaderCollectorService())
export const updateTagsActuLive = (id, tags) => axios.post(`${url_actulive}/${id}/tags`, tags, getHeaderCollectorService())

export const getLiveDetails = (idLive, date, mode, competition) => {
    let url = `${url_lives}/${idLive}`;

    return axios.get(url, getHeaderCollectorService({ mode, date, competition }));
};

export const getLiveInfo = (idLive) => axios.get(`${url_lives}/info/${idLive}`, getHeaderCollectorService())

export const getLiveDates = (idLive) => axios.get(`${url_lives}/dates/${idLive}`, getHeaderCollectorService())
export const getLiveCompetitions = (idLive) => axios.get(`${url_lives}/competitions/${idLive}`, getHeaderCollectorService())

export const getMatchDetail = (idMatch) => axios.get(`${url_matchdetail}/${idMatch}`, getHeaderCollectorService())
export const getPaginedMatchDetail = (idMatch, pagination) => axios.get(`${url_matchdetail}/${idMatch}/${pagination}`)
//full-export (sans pagination, pour téléchargement)
export const getMatchDetailFullExport = (idMatch) => axios.get(`${url_matchdetail}/export-full/${idMatch}`, getHeaderCollectorService())

export const getMatchData = (idMatch) => axios.get(`${url_data}/match/${idMatch}`, getHeaderCollectorService())
export const getGameFactsData = (idMatch) => axios.get(`${url_data}/gamefacts/${idMatch}`, getHeaderCollectorService())

export const getCompositions = (discipline) => axios.get(`${url_compositions}/${discipline}`, getHeaderCollectorService())
export const getPlayersPositions = (composition, options) => axios.get(`${url_compositions}/positions/${composition}`,getHeaderCollectorService({ options }))

export const createGameFact = (newGameFact) => axios.post(url_gamefact, newGameFact, getHeaderCollectorService())
export const updateGameFact = (id, updatedGameFactDetail) => axios.patch(`${url_gamefact}/${id}`, updatedGameFactDetail, getHeaderCollectorService())
export const updateGameFactData = (id, updatedGameFact) => axios.patch(`${url_gamefact}/asData/${id}`, updatedGameFact, getHeaderCollectorService())
export const deleteGameFact = (id) => axios.delete(`${url_gamefact}/${id}`, getHeaderCollectorService())
export const deleteGameFacts = (idMatch) => axios.delete(`${url_gamefact}/match/${idMatch}`, getHeaderCollectorService())
export const autoScoreGameFact = (deleteInfo, createInfo, idMatch) => axios.patch(`${url_gamefact}/autoScore`, {deleteInfo, createInfo, idMatch}, getHeaderCollectorService())

export const createNotation = (newNotation) => axios.post(url_notation, newNotation, getHeaderCollectorService())
export const updateNotation = (id, updatedNotation) => axios.patch(`${url_notation}/${id}`, updatedNotation, getHeaderCollectorService())
export const deleteNotation = (id) => axios.delete(`${url_notation}/${id}`, getHeaderCollectorService())
export const addNote = (id, note) => axios.patch(`${url_notation}/addnote/${id}`, note, getHeaderCollectorService())

export const createSurvey = (newSurvey) => axios.post(url_survey, newSurvey, getHeaderCollectorService())
export const updateSurvey = (id, updatedSurvey) => axios.patch(`${url_survey}/${id}`, updatedSurvey, getHeaderCollectorService())
export const deleteSurvey = (id) => axios.delete(`${url_survey}/${id}`, getHeaderCollectorService())

export const createQuizz = (newQuizz) => axios.post(url_quizz, newQuizz, getHeaderCollectorService())
export const updateQuizz = (id, updatedQuizz) => axios.patch(`${url_quizz}/${id}`, updatedQuizz, getHeaderCollectorService())
export const deleteQuizz = (id) => axios.delete(`${url_quizz}/${id}`, getHeaderCollectorService())

export const createQuestionBox = (newQuestionBox) => axios.post(url_questionbox, newQuestionBox, getHeaderCollectorService())
export const updateQuestionBox = (id, updatedQuestionBox) => axios.patch(`${url_questionbox}/${id}`, updatedQuestionBox, getHeaderCollectorService())
export const deleteQuestionBox = (id) => axios.delete(`${url_questionbox}/${id}`, getHeaderCollectorService())
export const deleteQuestionFromQuestionBox = (idQuestionBox, idQuestion) => axios.delete(`${url_questionbox}/${idQuestionBox}/question/${idQuestion}`, getHeaderCollectorService())

export const createArticle = (newArticle) => axios.post(url_article, newArticle, getHeaderAuthMultiPart())
export const createImages = (images) => axios.post(`${url_article}/images`, images, getHeaderAuthMultiPart())
export const updateArticle = (id, updatedArticle) => axios.patch(`${url_article}/${id}`, updatedArticle, getHeaderAuthMultiPart())
export const deleteArticle = (id) => axios.delete(`${url_article}/${id}`, getHeaderCollectorService())


export const importPlayers = (players) => axios.post(`${url_admin}/csv/players`, players, getHeaderCollectorService())
export const importTeams = (teams) => axios.post(`${url_admin}/csv/teams`, teams, getHeaderCollectorService())
export const importMatches = (matches, discipline, template) => axios.post(`${url_admin}/csv/matches`, { matches, discipline, template }, getHeaderCollectorService())
export const checkImportMatches = (matches, discipline, template) => axios.post(`${url_admin}/csv/matches/check`, { matches, discipline, template }, getHeaderCollectorService())
export const deleteMatches = (ids) => axios.post(`${url_admin}/csv/matches/remove`, ids, getHeaderCollectorService())
export const exportPlayers = (filters = {}) => axios.get(`${url_admin}/export-csv/players`, getHeaderCollectorService({ filters }))
export const exportTeams = (filters = {}) => axios.get(`${url_admin}/export-csv/teams`, getHeaderCollectorService({ filters }))
export const importCalendars = (calendars) => axios.post(`${url_admin}/csv/calendars`, { calendars }, getHeaderCollectorService())
export const exportCalendars = async (filters) => axios.post(`${url_admin}/export-csv/calendars`, { filters }, getHeaderCollectorService())

/* Cache API calls*/
export const getCacheConfigs = (params) => axios.get(`${url_admin}/cacheconfigs`, getHeaderCollectorService(params));
export const upsertCacheConfig = (payload) => axios.post(`${url_admin}/cacheconfigs`, payload, getHeaderCollectorService());

//add flag (force refresh) only - caches associated will be refreshed depends on config refresh mode
export const forceRefreshCacheConfig = (id) => axios.post(`${url_admin}/cacheconfigs/${id}/force-refresh`, {}, getHeaderCollectorService());
export const forceUnrefreshCacheConfig = (id) => axios.post(`${url_admin}/cacheconfigs/${id}/force-unrefresh`, {}, getHeaderCollectorService());

//trigger manual refresh now
export const refreshNowCacheConfig = (id) => axios.post(`${url_admin}/cacheconfigs/${id}/refresh-now`, {}, getHeaderCollectorService());
export const archiveCacheConfig = (id) => axios.post(`${url_admin}/cacheconfigs/${id}/archive`, {}, getHeaderCollectorService());
export const unarchiveCacheConfig = (id) => axios.post(`${url_admin}/cacheconfigs/${id}/unarchive`, {}, getHeaderCollectorService());
export const refreshNowCaches = (cacheIds) => axios.post(`${url_admin}/caches/refresh-now`, { cacheIds }, getHeaderCollectorService());

//delete cache
export const deleteCache = (cacheId) => axios.delete(`${url_admin}/caches/${cacheId}`, getHeaderCollectorService());

export const getCaches = (params) => axios.get(`${url_admin}/caches`, getHeaderCollectorService(params));
export const getCacheByRequestId = (requestId) => axios.get(`${url_admin}/caches/${requestId}`, getHeaderCollectorService());

export const getDefaultCacheTtls = (params) =>
  axios.get(`${url_admin}/cache/default-ttls`, getHeaderCollectorService(params));

export const updateDefaultCacheTtls = (payload) =>
  axios.post(`${url_admin}/cache/default-ttls`, payload, getHeaderCollectorService());

// Instance Axios personnalisée pour les requêtes longues
export const syncData = (filter) => axiosInstance.patch(`${url_data_sync}/webhook/send`, filter);

//TODO refacto pour utiliser fetchApiLogs - filtre dans webhook/logs v2 sync url
export const fetchLogsFromApi = () => axios.get(`${url_data_sync}/webhook/logs`, getHeaderCollectorService());
export const fetchApiLogs = (service, type) =>  axios.get(`${url_data_sync}/apis/logs/${service}/${type}`, getHeaderCollectorService());
// Force job flush errors - get job's queue status
export const fetchJobsQueuesStatus = () =>  axios.get(`${url_data_sync}/queues-status`, getHeaderCollectorService());
export const retryFailedJobs = () =>  axios.post(`${url_data_sync}/queues-status/retry-failed-jobs`, {}, getHeaderCollectorService());
//REDIS
export const getRedisStatus = () =>  axios.get(`${url_data_sync}/apis/redis-status`, getHeaderCollectorService());
export const redisReconnect = () =>  axios.post(`${url_data_sync}/apis/redis-reconnect`, {}, getHeaderCollectorService());
//BULLBOARD
export const forceReloadBull = () =>  axios.post(`${url_data_sync}/apis/reload-bull`, {}, getHeaderCollectorService());


// Fonction pour obtenir l'URL de Bull Board
export const getBullBoardUrl = async () => {
  return `${url_to_use}/v2/admin/queues`;
};